/** @jsxImportSource @emotion/react */
import { Redirect, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { auth as coreAuth } from '@sitebuilder/core';
import { StateShape as ReduxStateShape } from '../reducers';
import { actionCreators } from '../reducers/users';
import { actionCreators as envActionCreators } from '../reducers/envDiff';
import { actionCreators as authActionCreators } from '../reducers/auth';
// import Auth from '../components/Auth';
import Pages from '../components/Pages';
import Themes from '../components/Themes';
import Documents from '../components/Documents';
import Sites from '../components/Sites';
import Media from '../components/Media';
import Components from '../components/Components';
import Slidedecks from '../components/Slidedecks';
import ContentList from '../components/ContentList';
import EnvDiff from '../components/EnvDiff';
import TemplateEditor from '../TemplateEditor';
import Settings from '../components/Settings';
import SiteResourcesEditor from '../components/SiteResourcesEditor/index';
import ContentListEditor from '../components/ContentListEditor';
import '../scss/index.scss';
import { EditorPageViewer } from '../PageViewer';

const AdminRoutes = ({ user }: { user: coreAuth.User }) => {
    const {
        // user,
        accessToken,
        users,
    } = useSelector((state: ReduxStateShape) => {
        return {
            user: state.auth.user,
            accessToken: state.auth.user?.access_token,
            users: state.users?.users,
        };
    });

    const dispatch = useDispatch();

    const getInstanceData = async () => {
        const result: {} = await dispatch(actionCreators.loadUsersData(accessToken));
        return [result];
    };

    useEffect(() => {
        dispatch(authActionCreators.setUser(user));
    }, [user]);

    useEffect(() => {
        if (users === null) {
            const fetchData = async () => {
                await getInstanceData();
            };
            fetchData();
        }

        dispatch(envActionCreators.listEnvironments());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Switch>
            <Route exact path="/admin" render={() => <Redirect to="/admin/pages" />} />
            <Route exact path={`/admin/pages`} component={Pages} />
            <Route exact path={`/admin/themes`} component={Themes} />
            <Route path={`/admin/documents`} component={Documents} />
            <Route path={`/admin/sites`} component={Sites} />
            <Route path={`/admin/media`} component={Media} />
            <Route path={`/admin/settings`} component={Settings} />
            <Route exact path={`/admin/content-list`} component={ContentList} />
            <Route path={`/admin/resources`} component={SiteResourcesEditor} />
            <Route exact path={`/admin/components`} component={Components} />
            <Route exact path={`/admin/slidedecks`} component={Slidedecks} />
            <Route
                path={`/admin/pages/:documentName+`} // using + after param allows nested params
                component={TemplateEditor}
            />
            <Route
                // using + after param allows nested params
                path={`/admin/components/:libraryName/:componentId+`}
                component={TemplateEditor}
            />
            <Route
                // using + after param allows nested params
                path={`/admin/slidedecks/:libraryName/:slidedeckId+`}
                component={TemplateEditor}
            />
            <Route
                // using + after param allows nested params
                path={`/admin/themes/:themeId+`}
                component={TemplateEditor}
            />
            <Route path={`/admin/environments`} component={EnvDiff} />
            <Route
                // using + after param allows nested params
                path={`/admin/content-list/:contentListId+`}
                component={ContentListEditor}
            />
            <Route
                path={`/component/:libraryName/:componentId`}
                exact
                component={EditorPageViewer}
            />
            <Route
                path={`/slidedecks/:libraryName/:slidedeckId`}
                exact
                component={EditorPageViewer}
            />

            <Route path={`/:documentName+`} exact component={EditorPageViewer} />
        </Switch>
    );
};

export default AdminRoutes;
